import React from 'react';
import Anish from '../../assets/members/Anish.jpg';
import Niraj from '../../assets/members/niraj.jpg';
import Subin from '../../assets/members/subin.jpg';

import Mahesh from '../../assets/members/mahesh.jpg';
import Riyaj from '../../assets/members/riyaj.jpeg';
import Upasana from '../../assets/members/upasana.jpg';
import Sadeekshya from '../../assets/members/sadeekshya.jpeg';
import Sandesh from '../../assets/members/sandesh.png';
import Skrit from '../../assets/members/skrit.jpeg';

import './Members.css';

const Members = () => {
  const executiveMembers = [
    {
      name: 'Mahesh Raj Pandit',
      major: 'Computer Science',
      position: 'President',
      image: Mahesh
    },
    {
      name: 'Riyaj Chaulagain',
      major: 'Computer Science',
      position: 'Vice President',
      image: Riyaj
    },
    {
      name: 'Upasana Adhikari',
      major: 'Accounting',
      position: 'Treasurer',
      image: Upasana
    },
    {
      name: 'Skrit Simkhada',
      major: 'Information Technology',
      position: 'Secretary',
      image: Skrit
    },
    {
      name: 'Sandesh Bagale',
      major: 'Computer Science',
      position: 'Public Relation & Social Media Manager',
      image: Sandesh
    },
    {
      name: 'Sadeekshya Maharjan',
      major: 'Nursing',
      position: 'Public Relation & Social Media Manager',
      image: Sadeekshya
    },
  ];

  const websiteCollaborators = [
    {
      name: 'Anish Gyawali',
      image: Anish
    },
    {
      name: 'Subin Bista',
      image: Subin
    },
    {
      name: 'Niraj Bhatta',
      image: Niraj
    },
  ];

  return (
    <div className="members-container">
      <h1 className="members-heading">Executive Members</h1>
      <div className="members-grid">
        {executiveMembers.map((member, index) => (
          <div key={index} className="member-card">
            <img src={member.image} alt={member.name} className="member-photo" />
            <h3 className="member-name">{member.name}</h3>
            <p className="member-role">{member.position}</p>
            <p className="member-major">{member.major}</p>
          </div>
        ))}
      </div>

      <h1 className="members-heading">Website Collaborators</h1>
      <div className="members-grid">
        {websiteCollaborators.map((collaborator, index) => (
          <div key={index} className="member-card">
            <img src={collaborator.image} alt={collaborator.name} className="member-photo" />
            <h3 className="member-name">{collaborator.name}</h3>
            <p className="member-role">Web Contributor</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Members;
